var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialIconTuotiao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28731",
    transform: "translate(-.303)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 553",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(.303)",
    fill: "#dc212a"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28704",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16604",
    d: "M15.577 15.784v-1.167c.172-.007.332-.017.492-.02a1.32 1.32 0 00.586-.147c.515-.262 1.037-.511 1.555-.766.081-.04.162-.083.282-.146l-1.22-.473.72-1.059 2.074.769 2.686-1.324v-.285l-4.8.259-.977 1.539-1.449-.519c.047-.182 1.507-2.537 1.78-2.873.071.031.148.062.223.1.322.154.645.306.964.465a.749.749 0 00.391.084l3.543-.2 1.937-.107h.137v2.015l-2.834 1.41c.092.041.147.069.2.091.549.205 1.1.4 1.647.617a1.282 1.282 0 00.621.09c.16-.017.321-.027.514-.043 0 .2.006.4.008.587s0 .372 0 .581c-.249.019-.485.026-.718.058a2.193 2.193 0 01-1.113-.174c-.863-.336-1.736-.644-2.605-.964-.048-.017-.1-.032-.157-.052-.094.044-.193.09-.292.139l-2.746 1.35a1.034 1.034 0 01-.439.112c-.329.009-.659.035-1.01.053z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16605",
    d: "M5.441 20.422v-1.156l1.934-.122 1.582-2.09-3.529.2a4.2 4.2 0 01-.015-1.158l5.128-.306v-5.098l1.756-.1v5.067a7.489 7.489 0 001.079-.034c.355-.008.711-.031 1.083-.049v1.157l-3.273.194-2.482 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16606",
    d: "M20.981 15.228v.586l3.662-.2v1.162l-3.644.205v2.565l-1.763.087v-2.554l-3.66.208v-1.17l3.645-.192v-.584z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16607",
    d: "M12.766 19.978l-1.406-2.741 1.956-.089 1.415 2.725c-.675.053-1.315.081-1.965.105z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16608",
    d: "M16.745 17.563l1.762-.1-1.173 2.291-1.775.087z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16609",
    d: "M24.996 19.302l-1.753.1-1.3-2.139 1.767-.108z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16610",
    d: "M7.567 13.087l-1.412-1.791 1.938-.113 1.422 1.788z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16611",
    d: "M9.515 15.217l-1.943.108-1.418-1.791 1.939-.106z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconTuotiao);
export default __webpack_public_path__ + "static/media/social-icon-tuotiao.e23f0d895290d90fa61a569e63b36a0c.svg";
export { ForwardRef as ReactComponent };